import React from 'react';
import { Phone, Calendar } from 'lucide-react';
import { companyInfo } from '../mockData';

const TopBar = () => {
  return (
    <div className="bg-gray-900 text-white py-3">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-3">
          <div className="font-bold text-xl">
            {companyInfo.name}
          </div>
          <div className="flex flex-col sm:flex-row items-center gap-4">
            <a 
              href={`tel:${companyInfo.phone}`} 
              className="flex items-center text-lg font-bold hover:text-teal-400 transition-colors"
            >
              <Phone size={20} className="mr-2" />
              {companyInfo.phone}
            </a>
            <a
              href={`tel:${companyInfo.phone}`}
              className="flex items-center bg-teal-500 hover:bg-teal-600 text-white font-semibold px-4 py-2 rounded-md transition-colors"
            >
              <Calendar size={18} className="mr-2" />
              Schedule an Appointment
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
